// src/components/UserList.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import api from '../services/api';
import '../styles/styles.css';
import CryptoJS from 'crypto-js';


function ContactList({ discussionId, socket, onInvite, creatorId, onClose, prompt }) {
  const [contacts, setContacts] = useState([]);
  const [registeredContacts, setRegisteredContacts] = useState({});
const [search, setSearch] = useState('');
  const [cancellingId, setCancellingId] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  const navigate = useNavigate();
const { t } = useTranslation();
const baseContactsRef = useRef([]);



useEffect(() => {
  // ← Utiliser directement le localStorage au lieu de re-scanner les contacts
  const stored = JSON.parse(localStorage.getItem('contacts') || '[]');
  
  if (stored.length) {
    const formatted = stored.map(c => ({
      id: c.id,
      displayName: c.name,
      email: c.email,
    }));
    formatted.sort((a, b) => a.displayName.localeCompare(b.displayName));
baseContactsRef.current = formatted;
    checkRegisteredContacts(formatted);
  } else if (window.cordova && navigator.contacts) {
    // Fallback : re-scanner si localStorage vide
    handleImport();
  }
}, []);

  const markNotPending = (userId) =>
    setContacts((prev) => prev.map((c) => (c.userId === userId ? { ...c, isPending: false } : c)));


  


  const handleImport = () => {
    const options = {
      filter: "",
      multiple: true,
    };
    const fields = ["displayName", "name"];
    navigator.contacts.find(fields, onSuccess, onError, options);
  };

  const onSuccess = (contacts) => {
    const formattedContacts = contacts.map(contact => ({
      id: contact.id,
      displayName: contact.displayName || (contact.name ? contact.name.formatted : "Contact inconnu"),
      email: contact.emails && contact.emails.length > 0 ? contact.emails[0].value : null,
      
    }));

    // Trier par nom
    formattedContacts.sort((a, b) => a.displayName.localeCompare(b.displayName));

    checkRegisteredContacts(formattedContacts);
  };

  const onError = (err) => {
    console.error('Erreur lors de la récupération des contacts :', err);
  };

const hashContacts = (contacts) =>
  contacts.map(c => ({
    id: c.id,
    emailHash: c.email
      ? CryptoJS.SHA256(c.email.trim().toLowerCase()).toString()
      : null,
  }));

const [isChecking, setIsChecking] = useState(true);

  // checkRegisteredContacts reçoit les contacts avec email (usage local uniquement)
const checkRegisteredContacts = async (contacts) => {
  try {
    const hashedContacts = hashContacts(contacts); // hash pour le serveur
    const response = await api.post(
      `${API_URL}/api/list_users/check-contacts-invite`,
      { contacts: hashedContacts, discussionId }, // ← hash uniquement
    );

    const registeredContactsList = contacts.filter(contact => {
      const user = response.data[contact.id];
      return user && user._id !== creatorId;
    }).map(contact => {
      const user = response.data[contact.id];
      return {
        ...contact,
        email: contact.email, // ← conservé localement pour onInvite
        userId: user?._id,
        profileImage: user?.profileImage || null,
        profileImageUpdatedAt: user?.profileImageUpdatedAt || null,
        username: user?.username || null,
        isPending: user?.isPending || false,
      };
    });

    setContacts(registeredContactsList);
  } catch (error) {
    console.error('Erreur check-contacts-invite :', error);
  } finally {
    setIsChecking(false);  
  }
};

const handleCancelInvitation = async (contact) => {
    if (cancellingId) return;
    const { confirm, alert } = prompt;

    const ok = await confirm(t('inviter.confirm_cancel', { name: contact.username }));
    if (!ok) return;

    setCancellingId(contact.userId);
    try {
      const resp = await api.delete(`${API_URL}/api/list_users/${discussionId}/invitations/${contact.userId}`);
 
 await checkRegisteredContacts(baseContactsRef.current);
     // markNotPending(contact.userId);
    } catch (err) {
      const code = err.response?.data?.error;

      if (code === 'already_member') {
        await alert(t('inviter.already_member'));
      } else if (code === 'no_pending_invitation') {
       // markNotPending(contact.userId); 
checkRegisteredContacts(baseContactsRef.current);          
      } else {
        await alert(t('inviter.cancel_error'));
      }
    } finally {
      setCancellingId(null);
    }
  };

useEffect(() => {
  if (!socket) return;   // ← votre socket du contexte/props

  const handleParticipantJoined = ({ discussionId: joinedId, newParticipantId }) => {
    if (joinedId !== discussionId) return;

    // ✅ Le contact est devenu participant → refetch la source de vérité
    //    (check-contacts-invite renverra null pour lui → il disparaît de la liste)
    checkRegisteredContacts(baseContactsRef.current);
  };

  socket.on('participantJoined', handleParticipantJoined);
  return () => socket.off('participantJoined', handleParticipantJoined);
}, [socket, discussionId, checkRegisteredContacts]);
  const navigateToProfile = (userId) => {
  navigate(`/profile/${userId}`);
};

//const chatContainerRef = useRef(null);
const token = localStorage.getItem('token');
 return (
  <div style={{ padding: '1rem', position: 'relative', background: 'var(--bg-color)', borderRadius: 10, border: 1, overflowY: 'auto'  }} >
{/* Bouton close */}
  <button
    onClick={onClose}
    style={{
	display: 'none',
      position: 'absolute',
      top: '8px',
      right: '10px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--text-color)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 4,
      borderRadius: '50%',
    }}
    title={t('common.close')}
  >
    <i className="ti ti-circle-x"
          style={{ fontSize: '16px', color: 'var(--text-color)', opacity: 0.4 }}
          aria-hidden="true"
        />

  </button>
  {/* Header */}
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, paddingRight: 28 }}>
    <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: 'var(--title-color)' }}>
      {t('inviter.title')}
    </h3>
    <span style={{ fontSize: 12, color: 'var(--description-color)', background: 'var(--card-bg)', padding: '2px 10px', borderRadius: 20, border: '1px solid var(--li-border-color)' }}>
      {contacts.length} {t('participants.contacts')}
    </span>
  </div>

  {/* Recherche */}
  <input
    type="search"
    placeholder={t('diffusion.rechercher')}
    value={search}
    onChange={e => setSearch(e.target.value)}
    style={{ width: '100%', boxSizing: 'border-box', marginBottom: 10, fontSize: 13, padding: '8px 10px', borderRadius: 8, border: '1px solid var(--border-color)', background: 'var(--input-bg)', color: 'var(--input-color)', outline: 'none' }}
  />

  {/* Liste */}
  <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
    {contacts
      .filter(c => c.displayName.toLowerCase().includes(search.toLowerCase()))
      .map(contact => (
        <li key={contact.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px', borderRadius: 10, border: '1px solid var(--li-border-color)', background: 'var(--li-bg-color)', opacity: contact.isPending ? 0.6 : 1 }}>

          {/* Avatar */}
          {contact.profileImage ? (
            <img
              src={`${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${contact.userId}?token=${token}&type=image&thumb=true&profile=true&t=${contact.profileImageUpdatedAt}`}
              alt=""
              onClick={e => { e.stopPropagation(); navigateToProfile(contact.userId); }}
              style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, cursor: 'pointer', border: '1px solid var(--li-border-color)' }}
            />
          ) : (
            <div
              onClick={e => { e.stopPropagation(); navigateToProfile(contact.userId); }}
              style={{ width: 40, height: 40, borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 600, background: 'var(--toolbar-bg)', color: '#fff', cursor: 'pointer' }}
            >
              {contact.displayName.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)}
            </div>
          )}

          {/* Nom */}
          <span style={{ flex: 1, fontSize: 14, fontWeight: 500, color: 'var(--text-color)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {contact.username} ({contact.displayName})
          </span>

          {/* Bouton */}
{contact.isPending ? (
     <button
       onClick={() => handleCancelInvitation(contact)}
       disabled={cancellingId === contact.userId}
       title={t('inviter.cancel_invite')}
       style={{
         display: 'flex', alignItems: 'center', gap: 5,
         padding: '6px 12px', borderRadius: 8,
         border: '1px solid rgba(231,76,60,0.4)', background: 'rgba(231,76,60,0.08)',
         color: '#e74c3c', fontSize: 12, fontWeight: 500, cursor: 'pointer',
         whiteSpace: 'nowrap', flexShrink: 0,
       }}
     >

       <i className="ti ti-x" style={{ fontSize: 14 }} aria-hidden="true" />
       {t('inviter.cancel_invite')}
     </button>
) : (
         <button
  onClick={async () => {
    if (contact.isPending) return;
    const { confirm } = prompt;
    const confirmInvit = await confirm(t('inviter.alertinvite', { name: contact.username }));
    if (confirmInvit) {
const ok = await onInvite(contact.email);
if (ok) await checkRegisteredContacts(baseContactsRef.current);
}
  }}
  
  title={contact.isPending ? t('participants.invitation_envoyee') : t('inviter.invite')}
  style={{
    display: 'flex', alignItems: 'center', gap: 5,
    padding: '6px 12px', borderRadius: 8, border: 'none',
    background: contact.isPending ? 'var(--border-color)' : 'var(--create-public)',
    color: 'var(--button-text)', fontSize: 12, fontWeight: 500,
    cursor: contact.isPending ? 'default' : 'pointer',
    whiteSpace: 'nowrap', flexShrink: 0,
  }}
>
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <line x1="19" y1="8" x2="19" y2="14"/>
    <line x1="22" y1="11" x2="16" y2="11"/>
  </svg>
  {t('inviter.invite')}
</button>
)}
        </li>
      ))}
  </ul>
{/* Liste vide */}
{!isChecking && contacts.length === 0 && (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    padding: '32px 16px',
    textAlign: 'center',
  }}>
    <i className="ti ti-users-group"
      style={{ fontSize: 40, opacity: 0.2, color: 'var(--text-color)' }}
      aria-hidden="true"
    />
    <p style={{ margin: 0, fontSize: 14, color: 'var(--text-color)', opacity: 0.6, lineHeight: 1.5 }}>
      {t('inviter.nocontact1')}
    </p>
    <button
      onClick={() => navigate('/ImportContacts')}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '8px 16px',
        borderRadius: 20,
        border: 'none',
        background: 'var(--input-bg)',
        color: 'var(--input-color)',
        fontSize: 13,
        fontWeight: 500,
        cursor: 'pointer',
      }}
    >
      <i className="ti ti-share" aria-hidden="true" />
      {t('inviter.nocontact2')}
    </button>
  </div>
)}
</div>
);

}

export default ContactList;
